/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import {defineMessages} from 'react-intl'
import {
    HeartIcon,
    CavStoreIcon,
    CavHelpIcon,
    CowboyIcon,
    OrderIcon,
    InvertedLocatorIcon,
    CavendersIcon
} from '../../components/icons'

export const messages = defineMessages({
    home: {defaultMessage: 'Home', id: 'global.home.link.home'},
    dashboard: {defaultMessage: 'Account Dashboard', id: 'global.account.link.account_dashboard'},
    profile: {defaultMessage: 'Profile', id: 'global.account.link.profile'},
    addresses: {defaultMessage: 'Addresses', id: 'global.account.link.addresses'},
    orders: {defaultMessage: 'Orders', id: 'global.account.link.orders'},
    orderDetails: {defaultMessage: 'Order Details', id: 'global.account.link.order_details'},
    wishlist: {defaultMessage: 'Wishlist', id: 'global.account.link.wishlist'},
    myCavenders: {defaultMessage: `My Cavender's`, id: 'global.account.link.my_cavenders'},
    help: {defaultMessage: 'Help', id: 'global.account.link.contact'}
})

export const navLinks = [
    {
        name: 'dashboard',
        path: '/account/dashboard',
        icon: CavStoreIcon
    },
    {
        name: 'orders',
        path: '/account/orders',
        icon: OrderIcon
    },
    {
        name: 'profile',
        path: '/account/info',
        icon: CowboyIcon
    },
    {
        name: 'addresses',
        path: '/account/addresses',
        icon: InvertedLocatorIcon
    },
    {
        name: 'myCavenders',
        path: '/account/rewards',
        icon: CavendersIcon,
        hideName: true
    },
    {
        name: 'wishlist',
        path: '/account/wishlist',
        icon: HeartIcon
    },
    {
        name: 'help',
        path: '/help',
        exact: true,
        icon: CavHelpIcon
    }
]

export const CONFIRMATION_DIALOG_DEFAULT_CONFIG = defineMessages({
    dialogTitle: {
        defaultMessage: 'Confirm Action',
        id: 'confirmation_modal.default.title.confirm_action'
    },
    confirmationMessage: {
        defaultMessage: 'Are you sure you want to continue?',
        id: 'confirmation_modal.default.message.you_want_to_continue'
    },
    primaryActionLabel: {defaultMessage: 'Yes', id: 'confirmation_modal.default.action.yes'},
    primaryActionAriaLabel: {
        defaultMessage: 'Yes, confirm action',
        id: 'confirmation_modal.default.assistive_msg.yes'
    },
    alternateActionLabel: {defaultMessage: 'No', id: 'confirmation_modal.default.action.no'},
    alternateActionAriaLabel: {
        defaultMessage: 'No, cancel action',
        id: 'confirmation_modal.default.assistive_msg.no'
    }
})
